// Cores da pílula "Gratuito" nos cards de evento (EventPublicCard e card do
// HeroCarouselV2) — laranja do app. Só cor: tamanho/formato/fonte ficam em
// cada componente, como já eram.
export const FREE_PILL_COLOR_CLASS = 'bg-[#FF6A00] text-white';
